import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  RESET_JOB,
} from "../../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
  data: {},
};

const registerReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_REQUEST: // Handle fetching job request
      return {
        ...state,
        isLoading: true,
      };
    case REGISTER_SUCCESS: // Handle fetching job success
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        message: action.payload.message,
        data: action.payload.data, // Store fetched job data
      };
    case REGISTER_FAILURE: // Handle fetching job failure
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        message: action.payload.message,
      };
    case RESET_JOB: // Reset job data
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default registerReducer;
